export const MESSAGE = 'MESSAGE';
export const VISIBILITY = 'VISIBILITY';
export const RESET = 'RESET';
